module.exports = __webpack_public_path__ + "static/img/ninja-can-33.e14f28d7.png";